<section class="p-1" [ngClass]="{'type-b': templateSuffix !== ''}">
  <div class="flex-container mt-2" *ngIf="icon !== 'none'">
    <mat-icon [svgIcon]="icon"> </mat-icon>
  </div>

  <div class="mt-3" *ngIf="icon !== 'none'"></div>

  <mat-dialog-content class="mat-typography">
    <p class="title" *ngIf="title" [innerHTML]="title"></p>
    <p class="fuente" [innerHTML]="content"></p>
  </mat-dialog-content>

  <mat-dialog-actions [ngClass]="getJustify()">
    <button *ngIf="btnAction0" class="btn btn-action1" [mat-dialog-close]="true" mat-button [id]="idBtnAction0">
      {{ btnAction0 }}
    </button>
    <button *ngIf="btnAction2" class="btn btn-action2" [mat-dialog-close]="false" mat-button [id]="idBtnAction2">
      {{ btnAction2 }}
    </button>
    <button *ngIf="btnAction1" class="btn btn-action1" [mat-dialog-close]="true" mat-button [id]="idBtnAction1">
      {{ btnAction1 }}
    </button>
  </mat-dialog-actions>
</section>
